import { useEffect, useState } from 'react';
import ScreensConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config';

interface ScreenSize {
  SM: boolean;
  MD: boolean;
  LG: boolean;
  XL: boolean;
  '2XL': boolean;
}

const breakpoints = {
  SM: ScreensConfig(tailwindConfig).theme.screens.sm,
  MD: ScreensConfig(tailwindConfig).theme.screens.md,
  LG: ScreensConfig(tailwindConfig).theme.screens.lg,
  XL: ScreensConfig(tailwindConfig).theme.screens.xl,
  '2XL': ScreensConfig(tailwindConfig).theme.screens['2xl'],
};

const initialScreenSize: ScreenSize = {
  SM: false,
  MD: false,
  LG: false,
  XL: false,
  '2XL': false,
};
export default function useScreenSize() {
  const [isScreenLargerThan, setIsScreenLargerThan] = useState<ScreenSize>(initialScreenSize);

  useEffect(() => {
    const checkScreenSize = () => {
      const SM = window.innerWidth >= parseInt(breakpoints.SM, 10);
      const MD = window.innerWidth >= parseInt(breakpoints.MD, 10);
      const LG = window.innerWidth >= parseInt(breakpoints.LG, 10);
      const XL = window.innerWidth >= parseInt(breakpoints.XL, 10);
      const _2XL = window.innerWidth >= parseInt(breakpoints['2XL'], 10);
      setIsScreenLargerThan({ SM, MD, LG, XL, '2XL': _2XL });
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return { isScreenLargerThan };
}
